import React, { Fragment, memo } from 'react';

import Popup from '../helpers/Popup';
import BaseButton from '../helpers/Button';
import LoadAnimation from '../decorators/LoadAnimation';
import Checkbox from '../helpers/Checkbox';
import FormGroup from '../helpers/FormGroup';

const Button = LoadAnimation(BaseButton, undefined, undefined, true);

const AgreementCategoriesPopupComponent = ({ agreementCategoriesList, initialValues, onClose, onChange }) => {
  const header = (
    <div className="d-flex justify-content-space-between">
      Agreement Categories
      <a className="font-size-14 mr10" href="/categories-management" target="_blank">
        Categories Management
      </a>
    </div>
  );

  const footer = (
    <Button key="close" data-dismiss="modal" onClick={onClose}>
      Close
    </Button>
  );

  const isDefaultChecked = categoryId =>
    initialValues
      .toJS()
      .flatMap(value => value.children)
      .find(child => child.id === categoryId);

  return (
    <Popup footer={footer} header={header} id="addAgreementCategories">
      <div className="row">
        {agreementCategoriesList?.map((agreementCategory, index) => (
          <Fragment key={agreementCategory.id}>
            <div className="col-sm-4">
              <FormGroup>
                <p className="form-section-label">{agreementCategory.category}</p>
                <div>
                  {agreementCategory.children.map(category => (
                    <Checkbox
                      key={category.id}
                      defaultChecked={isDefaultChecked(category.id)}
                      label={category.category}
                      name={category.id}
                      onChange={() => onChange(category)}
                      value={category.id}
                    />
                  ))}
                </div>
              </FormGroup>
            </div>
            {(index + 1) % 3 === 0 ? <div className="clearfix" /> : null}
          </Fragment>
        ))}
      </div>
    </Popup>
  );
};

export const AgreementCategoriesPopup = memo(AgreementCategoriesPopupComponent);
